import { Component, OnInit, ViewChild, Input, Output, AfterViewInit, OnDestroy, Renderer2, ElementRef, ContentChildren, QueryList, HostListener, EventEmitter } from '@angular/core';
import { BeachSite } from 'src/app/models/BeachSite';
import { SitesFilter } from 'src/app/models/SitesFilter';
import { SitesService } from 'src/app/services/sites.service';
import { BehaviorSubject, Subject, Subscription, distinctUntilChanged, Observable } from 'rxjs';
import { BeachsitesListService } from '../beachsites-list-service';
import { NSWMapBounds, SITESLIST_REFRESH_INTERVAL_SECONDS } from 'src/app/models/app-constants';
import { isNumber } from 'lodash';
import { GoogleMapsApiLoaderService } from 'src/app/GoogleMapsApiLoaderService';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SitePopupInfoModel } from 'src/app/models/SiteDetails/SitePopupInfoModel';
import { BeachWatchGoogleMapComponent, MapBoundsChangedEvent } from '../beach-watch-google-map/beach-watch-google-map.component';

import { SiteWeatherForecastModel } from 'src/app/models/SiteDetails/SiteWeatherForecastModel';

import { ZoomToSearchResultService } from '../ZoomToSearchResultService';
import { FilterResultsSideNavComponent } from '../filter-results-side-nav/filter-results-side-nav.component';
import { UpdateSitePollForecast } from 'src/app/models/Site';


function isLatLngBounds(object: any)  {	
    return 'north' in object && 'south' in object && 
		'west' in object && 'east' in object &&
		isNumber(object["north"]) && isNumber(object["south"]) &&
		isNumber(object["west"]) && isNumber(object["east"]);
}

@Component({
	selector: 'app-maps-section',
	templateUrl: './maps-section.component.html',
	styleUrls: ['./maps-section.component.scss'],
	providers: [SitesService],
})

export class MapsSectionComponent implements OnInit, AfterViewInit, OnDestroy {
	
	/*	
		All the beach sites are passed down from the home component to maps section componentand search component.
		Pollution forecasts are run on the server everyday at 6 am and 1:30 pm.
		In the home component, sites are fetched every 5 minutes and redrawn on the map.
		However there may occur a time when the pollution forecast returned by a site's pop-up info is different from that site's
		pollution forecast when it was draw on the map during the previous refresh. 
		So we have inform the parent component i.e home to update the site or fetch all the sites again/
		redrawSites is the event that is emitted to update the a site's pollution forecast in the parent.
	*/
	@Output() updateSitePollutionForecast : EventEmitter<UpdateSitePollForecast> = new EventEmitter<UpdateSitePollForecast>();

	private sitesFilter : SitesFilter;
	public siteLinkClickedEvent$ : Subject<BeachSite> = new Subject<BeachSite>();	
	public filteredList$ : BehaviorSubject<BeachSite[]> = new BehaviorSubject<BeachSite[]>([]);
	
	private __allBeachSites$ = new BehaviorSubject<BeachSite[]>([]);	
	private mapBounds : BehaviorSubject<any> = new BehaviorSubject({bounds : NSWMapBounds, zoomToCurrentLocation : false});
	private mapBoundsSubscription : Subscription;
	private sitesSubscription : Subscription;	
	filterByKeyword : string = "";

	isTabView : boolean = false;
	breakpoint : string = '(min-width: 992px)';   
    currentBreakpoint:string = '';
	private breakpointSub : Subscription;
	mapView : boolean = true;

	static readonly INFO_WINDOW_WIDTH = 380;
	static readonly INFO_WINDOW_HEIGHT = 650;

	sitesListHeight : string;

    readonly breakpoint$ = this.breakpointObserver.observe(this.breakpoint).pipe(distinctUntilChanged());
	
	@ViewChild("beachSitesListElement", { read : ElementRef }) beachSitesListElementRef : ElementRef;
 	@ViewChild("mapSection", { read : ElementRef}) mapSectionRef : ElementRef;	
	@ViewChild("mapInfoWindow", { read : ElementRef }) infoWindowElementRef : ElementRef;
	@ViewChild(BeachWatchGoogleMapComponent) mapComponent : BeachWatchGoogleMapComponent;
	@ViewChild(FilterResultsSideNavComponent) filterResultsSideNav : FilterResultsSideNavComponent;

	public showFilterResultsSideNav : boolean = false;
	public filterActive: boolean = false;

	private zoomToSearchSub : Subscription;
	private scrollMapIntoViewSub : Subscription;

	bodyScrollAttribute : string = "";

	popperInstance : any = null;
	isPopupShown : boolean;
	sitePopupInfo : SitePopupInfoModel;
	popupPosition : google.maps.LatLng | null;	
	popperPosition = { x : 0, y : 0, mapHeight : 0};
	
	popupConfig : { 
		siteId : string; 
		position : google.maps.LatLng;
		popupInfo? : SitePopupInfoModel;
		activeElement : any
	} | null;	

	markerOutOfBounds : boolean;

	private filterPaneOpen: boolean;
	public marginTop: string;
	public height: string;
	private parentTop: Observable<ElementRef>;
	@ViewChild("filterResultsPanel", { read : ElementRef }) filterResultsPanel : ElementRef;
	popupClosedSubject : Subject<void> = new Subject<void>();

	constructor(private sitesService : SitesService, 		
		private breakpointObserver : BreakpointObserver,
		private zoomToSearchService: ZoomToSearchResultService,
		private renderer : Renderer2) 
	{
		this.sitesFilter = new SitesFilter([], [],[],[]); 		
	}

	@Input()
	get allBeachSites()  {
		return this.__allBeachSites$.getValue();
	}

	set allBeachSites(value) {
		this.__allBeachSites$.next(value);
	}	

	ngOnInit(): void {
		this.subscribeToMapBoundsChanged();
		this.subscribeToAllBeachesCollectionChanged();	
		this.breakpointSub = this.breakpoint$.subscribe({
			next : (result) => 
			{
				this.isTabView = !result.matches;
			},
			error : (ex) => {

			},
			complete : () => {				
			}
		});	

		this.zoomToSearchSub = this.zoomToSearchService.zoomToData.subscribe({
			next: (data: any) => {
				if(this.isTabView)
				{
					!this.mapView && (this.mapView = true);					
				}
				this.scrollMapIntoView();				
			}
		});
		
		// this.scrollMapIntoViewSub = this.zoomToSearchService.scrollMapIntoView.subscribe({
		// 	next: (data: any) => {
		// 		if(data)
		// 		{
		// 			this.scrollMapIntoView();				
		// 		}							
		// 	}
		// });
	}

	private scrollMapIntoView = () => {
		//if(this.isTabView)					
		{
			// 	
			//	https://bis-jira.atlassian.net/browse/BW-23 : Acceptance criteria 2D : Scroll the map into view if it's out of view.
			//
			const mapViewSection = document.querySelector("#tabContent");
			const mapViewSectionRect = mapViewSection?.getBoundingClientRect();
			const windowBottom = window.screenTop + window.innerHeight;				

			if(mapViewSection && mapViewSectionRect)
			{				
				const isInViewport = mapViewSectionRect?.top >= 0 &&
					mapViewSectionRect?.left >= 0 &&
					mapViewSectionRect?.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					mapViewSectionRect?.right <= (window.innerWidth || document.documentElement.clientWidth);
				if(!isInViewport)
				{
					const scrollX = 0;
					const scrollY = document.documentElement.clientTop - mapViewSectionRect.top + 
						(document.documentElement.clientHeight - mapViewSection?.clientHeight) / 2
					window.scrollBy({ top : -scrollY, left : 0, behavior : 'smooth' });						
				}
			}
		}
	}

	
	ngAfterViewInit(): void {
		const siteslist = document.querySelector("#beachSitesList")?.getBoundingClientRect();	
		const desktopViewInfo = document.querySelector("#desktopViewInfo")?.getBoundingClientRect();
		const filterSection = document.querySelector("#filterSection")?.getBoundingClientRect();
		const frame2112 = document.querySelector("#frame-2112")?.getBoundingClientRect();
		const filterTextField = document.querySelector("#filter-text-field")?.getBoundingClientRect();
		const legend = document.querySelector("#legend")?.getBoundingClientRect();
		if(siteslist && desktopViewInfo && filterSection && frame2112 && filterTextField && legend)
		{
			this.sitesListHeight = (siteslist?.height - desktopViewInfo?.height - filterSection?.height 
				- frame2112?.height - filterTextField?.height - legend?.height) + "px";
		}
	}

	ngOnDestroy() {
		this.mapBoundsSubscription && this.mapBoundsSubscription?.unsubscribe();
		this.sitesSubscription && this.sitesSubscription?.unsubscribe();
		this.breakpointSub && this.breakpointSub.unsubscribe();
		this.zoomToSearchSub && this.zoomToSearchSub?.unsubscribe();
		this.scrollMapIntoViewSub && this.scrollMapIntoViewSub?.unsubscribe();
	}	

	private subscribeToMapBoundsChanged = () => {
		this.mapBoundsSubscription = this.mapBounds.subscribe({
			next : (data) => 
			{
				this.refreshSitesList();				
			},
			error : (ex) => {
				console.log(ex);
			},
			complete : () => {

			}
		});
	}

	private subscribeToAllBeachesCollectionChanged = () => {
		this.sitesSubscription = this.__allBeachSites$.subscribe({
			next : (data) => 
			{
				this.refreshSitesList();
				
			},
			error : (ex) => {
				console.log(ex);
			},
			complete : () => {

			}
		});	
	}

	private refreshSitesList() {
		const list = this.allBeachSites?.filter((site : BeachSite, index : number) => {				
			const siteInBounds = this.boundsContains(site);
			const matchesKeyword = !this.filterByKeyword?.trim() ? true :
				site.SiteName?.toLocaleLowerCase().includes(this.filterByKeyword?.trim().toLocaleLowerCase());
			const matchesFilter = this.sitesFilter.isSiteMatch(site);
			return siteInBounds && matchesKeyword && matchesFilter;				
		});	
		this.filteredList$.next(list);
	}


	private boundsContains(site : BeachSite) {
		let contains = false;
		if(this.mapBounds)
		{			
			const event = this.mapBounds?.getValue();
			if(event?.zoomToCurrentLocation)
			{
				return true;
			}
			if( google?.maps?.LatLngBounds && event?.bounds instanceof google.maps.LatLngBounds)
			{
				contains = event?.bounds?.contains({lat : site.Lat, lng : site.Lng });
			}
			else 
			{
				if(isLatLngBounds(event?.bounds))
				{					
					contains = site.Lat <= event?.bounds?.north && site.Lat >= event?.bounds?.south && 
					site.Lng >= event?.bounds?.west && site.Lng <= event?.bounds?.east;
				}
			}
		}	
		return contains;
	}

	get sites() : BeachSite[] {			
		const list = this.filteredList$.getValue();		
		return list;
	}

	onSiteLinkClicked(site : BeachSite) {
		if(this.isTabView)
		{
			this.mapView = true;
		}
		this.siteLinkClickedEvent$.next(site);
	}

	
	onMapBoundsChanged(event : MapBoundsChangedEvent) 
	{		
		if(event?.bounds)
		{	
			this.mapBounds.next(event);	
		}
	}	

	onMapIdle(mapBounds : google.maps.LatLngBounds | undefined)
	{
		if(this.isPopupShown)
		{	
			//this.calculateInfoWindowPosition(mapBounds);			
		}

		if(null != this.popupConfig && this.popupConfig?.siteId && this.isPopupShown)
		{
			const beachSite = this.allBeachSites.find((site : BeachSite) => site.Identifier === this.popupConfig?.siteId);					
			if(beachSite && this.popupConfig?.popupInfo?.PollutionForecast && 
				beachSite.PollutionForecast?.toString()?.toLowerCase() !== this.popupConfig?.popupInfo?.PollutionForecast?.toString()?.toLowerCase()
			)
			{	
				this.updateSitePollutionForecast.emit({ siteId : this.popupConfig?.siteId, 
					pollutionForecast : this.popupConfig?.popupInfo?.PollutionForecast!.toString() 
				});				
			}
		}
	}		

	onFilterKeywordChanged = (event : any) => {
		this.refreshSitesList();
	}

	onTabItemClicked = (isMapView : boolean = true) =>
	{
		this.mapView = isMapView;
		if(!isMapView)
		{
			this.isPopupShown = false;
		}
	}
	
	@HostListener("window:scroll", []) onWindowScroll() {
		if(this.isPopupShown)
		{
			this.calculateInfoWindowPosition(this.mapComponent?.googleMapRef?.googleMap?.getBounds(), true);
		}
	}	

	@HostListener("window:resize", []) onWindowResize() {
		if(this.isPopupShown)
		{
			this.calculateInfoWindowPosition(this.mapComponent?.googleMapRef?.googleMap?.getBounds(), true);
		}
	}	
	

	displayPopup (event : any) {
		if(!this.mapComponent)
		{
			this.isPopupShown = false;
			return;
		}

		const { siteId, position, activeElement, popupInfo } = event;
		if(siteId)
		{			
			//this.isTabView && 
			this.scrollMapIntoView();

			
			this.isPopupShown = true;
			this.popupConfig = { 
				siteId : siteId, 						
				popupInfo : popupInfo,						
				position : position,
				activeElement : activeElement
			};					
			this.calculateInfoWindowPosition();	


			// this.sitesService.getSitePopupInfo(siteId).subscribe({
				
			// 	next : (data: any) => {
			// 		if(!data?.Identifier)
			// 		{
			// 			this.isPopupShown = false;
			// 			return;
			// 		}
			// 		const popupInfo  = <SitePopupInfoModel>{...data,
			// 			LatestResultDate : null != data.LatestResultDate ? new Date(Date.parse(data.LatestResultDate)) : null,
			// 			PollForecastDateTime : null != data.PollForecastDateTime ? new Date(Date.parse(data.PollForecastDateTime)) : null,
			// 			WeatherForecast : <SiteWeatherForecastModel>{
			// 				...data.WeatherForecast, 
			// 				FirstTideHighTime : null != data?.WeatherForecast?.FirstTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.FirstTideHighTime)) : null,
			// 				FirstTideLowTime : null != data?.WeatherForecast?.FirstTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.FirstTideLowTime)) : null,
			// 				NextTideHighTime : null != data?.WeatherForecast?.NextTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.NextTideHighTime)) : null,
			// 				NextTideLowTime : null != data?.WeatherForecast?.NextTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.NextTideLowTime)) : null,
			// 				SecondTideHighTime : null != data?.WeatherForecast?.SecondTideHighTime ? new Date(Date.parse(data?.WeatherForecast?.SecondTideHighTime)) : null,
			// 				SecondTideLowTime : null != data?.WeatherForecast?.SecondTideLowTime ? new Date(Date.parse(data?.WeatherForecast?.SecondTideLowTime)) : null
			// 			}
			// 		};						
					
			// 		this.isPopupShown = true;
			// 		this.popupConfig = { 
			// 			siteId : siteId, 						
			// 			popupInfo : popupInfo,						
			// 			position : position,
			// 			activeElement : activeElement
			// 		};					
			// 		this.calculateInfoWindowPosition();					
			// 	},
			// 	error : (error) => {
			// 		this.isPopupShown = false;					
			// 	},
			// 	complete : () => 
			// 	{

			// 	}
			// });
		}		
	}	

	getOffset(el : any) 
	{
		const rect = el.getBoundingClientRect();
		const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
	}

	getPosition(element : any) {
		const  clientRect = element.getBoundingClientRect();
		return {left: clientRect.left + document.body.scrollLeft,
				top: clientRect.top + document.body.scrollTop};
	}

	appContainerOverFlow : any;
	
	private calculateInfoWindowPosition = (mapBounds? : google.maps.LatLngBounds, scroll = false) => {
		if(!this.mapComponent || null == this.popupConfig || 
			(this.popupConfig?.siteId !== this.popupConfig?.popupInfo?.Identifier))
		{
			this.isPopupShown = false;
			return;
		}		

		const popupPosition = this.popupConfig.position!;
		this.markerOutOfBounds = !this.mapComponent?.googleMapRef?.googleMap?.getBounds()?.contains(popupPosition);		

		const point = this.mapComponent.fromLatLngToPoint(popupPosition, mapBounds);
		if(point)
		{	
			const mapRect = this.mapComponent.googleMapRef?.googleMap?.getDiv()?.getBoundingClientRect();
			//this.popperPosition = { x : point.x + mapRect?.left!, y : point.y + mapRect?.top!, mapHeight : mapRect?.height ?? 0 };
		}

		const sitesListDiv = document.querySelector("#beachSitesList");
		//const sitesListDiv = this.beachSitesListElementRef?.nativeElement;
		const sitesListRect = sitesListDiv?.getBoundingClientRect();
		const mapDiv = this.mapComponent?.googleMapRef?.googleMap?.getDiv();
		const mapRect = mapDiv?.getBoundingClientRect();
		
		const infoWindowElement = document.querySelector("#infowWindowContainer");
		const infoWindoRect = infoWindowElement?.getBoundingClientRect();	
		const mapInfoWindowElement = document.querySelector("#mapInfoWindow");
			
		if(mapRect && sitesListRect)
		{	
			const listOffsetLeft = sitesListRect.left - mapRect.left;
			const width = (mapRect.width - listOffsetLeft) / 2;
			const leftWidth = listOffsetLeft +  sitesListRect.width;
			const rightWidth = mapRect.width - leftWidth;
			
			//let offsetX = sitesListRect.right + (mapRect?.right - sitesListRect.right) / 2 ;
			//offsetX = listOffsetLeft + (rightWidth / 2);
			const offsetX = !this.isTabView ? (mapRect.right - rightWidth / 2) : mapRect?.width / 2;
			
			const infoWindowHeight = infoWindoRect?.height || 650;
			const offsetY = 3 * mapRect.height / 4; 

			const positionToPixel = this.mapComponent?.fromLatLngToPoint(this.popupConfig?.position);
			const mapCenter = this.mapComponent?.googleMapRef?.googleMap?.getCenter();
			
			const dX = offsetX - positionToPixel.x;			
			const dY = offsetY - positionToPixel.y;			
			
			if(!this.isTabView)
			{
				//const latLngPosition = this.mapComponent?.pixelOffsetToLatLng(offsetX, offsetY);				
				!scroll && this.mapComponent?.googleMapRef?.googleMap?.panBy(-dX, -dY);				
				this.popperPosition = { x : offsetX, y : mapRect.top + offsetY , mapHeight : mapRect?.height ?? 0 };
			}
			else
			{					
				const overlayRect = document.querySelector("#overlay")?.getBoundingClientRect();				
				
				const windowBottom = window.screenTop + window.innerHeight;
				const y = windowBottom - (window.innerHeight - 650) / 2;
				
				this.mapComponent?.googleMapRef?.googleMap?.setCenter(popupPosition);
				this.popperPosition = { x : window.innerWidth / 2, y : y, mapHeight : mapRect?.height ?? 0 };
				this.appContainerOverFlow = document.body.style.overflow;	
				// main-nav-active is class defined in NSW design scss
				if(!document.body.classList.contains("main-nav-active"))
				{
					//this.renderer.removeStyle(document.body, "main-nav-active");
					document.body.classList.add("main-nav-active");
				}
				//document.body.style.overflow = "hidden";
			}			
		} 
	}

	onSitePopupClosed = (event : any) => {
		this.closePopup();
	}	

	closePopup() {
		if(this.isTabView)
		{
			this.renderer.removeStyle(document.body, "main-nav-active");
			// main-nav-active is class defined in NSW design scss			
			if(document.body.classList.contains("main-nav-active"))
			{
				document.body.classList.remove("main-nav-active");
			}
			
			//document.body.style.overflow = 'auto';
		}		
		this.isPopupShown = false;
		this.markerOutOfBounds = false;
		this.popupPosition = null;	
		if(this.popupConfig?.activeElement)			
		{
			this.popupConfig?.activeElement?.focus();
		}
		this.popupClosedSubject.next();		
		this.popupConfig = null;		
	}

	onSitesFilterUpdate(filter: SitesFilter){
		this.sitesFilter = filter;
		this.filterActive = 0 < this.sitesFilter.councils.length || 
			0 < this.sitesFilter.regions.length || 0 < this.sitesFilter.sites.length ||
			0 < this.sitesFilter.siteTypes?.length;
		this.refreshSitesList();
	}	

	onFilterResultsClick(event: any) {
		event.preventDefault();
		event.stopPropagation();
		this.filterPaneOpen = !this.filterPaneOpen;
		window.scrollTo({
			top:
				this.filterResultsPanel?.nativeElement?.parentElement.getBoundingClientRect()
					?.top + window.scrollY,
			behavior: 'auto',
		});		
	}
	

	public onClearFilterClick(event: Event) {
		event.preventDefault();
		event.stopPropagation();		
		this.filterResultsSideNav?.clearFilter();
	}
}

 